const STORAGE_KEY = 'management.navExpandedState';

/**
 * Persistence pair for KeyDS `useStickyLeftNav`, so a user's expanded/collapsed
 * LeftNav choice survives navigation. Portal navigates with full page loads, so
 * this has to outlive the React tree — localStorage rather than in-memory state.
 *
 * Access is wrapped because localStorage throws rather than returning null when
 * storage is unavailable (Safari private mode, cookies blocked). A user who
 * can't persist the preference should still get a working nav.
 */
export function getPreferredNavExpandedState() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || undefined;
  } catch (e) {
    return undefined;
  }
}

export function setPreferredNavExpandedState(navExpandedState) {
  try {
    if (navExpandedState) {
      window.localStorage.setItem(STORAGE_KEY, navExpandedState);
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch (e) {
    // Preference is best-effort; losing it must not break navigation.
  }
}

export default { getPreferredNavExpandedState, setPreferredNavExpandedState };
